import React, {useEffect, useState} from "react";
import OpsInput from "../../ops-library/ops-input";
import OpsText from "../../ops-library/ops-text";
import OpsBtn from "../../ops-library/ops-btn";
import {FaTrashCan} from "react-icons/fa6";
import {Modal} from "react-bootstrap";
import opsToast from "../../ops-library/ops-toast";
import axios from "axios";
import {BiSolidEdit} from "react-icons/bi";
import {hasRoleAccess} from "../../functions/hasRoleAccess";
import {LoadingSpinner} from "../LoadingSpinner";
import {opsConfirmDialog} from "../../ops-library/ops-confirm-dialog";
import {ACCESS_TOKEN_KEY} from "../../constants/constants";
import OpsToast from "../../ops-library/ops-toast";
import formatDate from "../../functions/formatDate";
import {FaPlus} from "react-icons/fa";
import OpsTable from "../../ops-library/ops-table";
import OpsIconStatus from "../../ops-library/ops-icon-status";
import {TbRestore} from "react-icons/tb";

const AdminProducts = ({sectionId, theme, user}) => {
    const token = localStorage.getItem(ACCESS_TOKEN_KEY);
    const [products, setProducts] = useState(null)
    const [showDeleted, setShowDeleted] = useState(false)
    const [modalProductShown, setModalProductShown] = useState(false);
    const [loading, setLoading] = useState(true)
    const [modalData, setModalData] = useState(null);

    useEffect(() => {
        getProducts();
    }, []);

    // API functions - get/patch/restore
    // ------------------------------------------------------------------------------
    function getProducts(showDeleted = false) {
        setLoading(true)
        const configuration = {
            method: "get",
            url: `${process.env.REACT_APP_API_BASE_URL}/products?includeDeleted=${showDeleted}`,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        axios(configuration)
            .then((result) => {
                setProducts(result.data.content)
                setLoading(false)
            })
            .catch((error) => {
                opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
            });
    }

    function restoreProduct(id) {
        setLoading(true)
        const configuration = {
            method: "patch",
            url: `${process.env.REACT_APP_API_BASE_URL}/products/restore/${id}?includeDeleted=${showDeleted}`,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        axios(configuration)
            .then((result) => {
                if (result.data.content !== undefined) {
                    setProducts(result.data.content)
                    OpsToast(result.data.message, "success")
                }
            })
            .catch((error) => {
                opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
            });
        setLoading(false)
    }

    // MODALS
    // ------------------------------------------------------------------------------
    function handleOpenModalProduct(data) {
        if (data) {
            setModalData(data)
            setModalProductShown(true);
        } else {
            setModalData(null);
            setModalProductShown(true);
        }
    }

    function handleModalsClose() {
        setModalProductShown(false)
        setModalData(null)
    }

    const ModalProduct = ({show = false, onHide}) => {

        const [processed, setProcessed] = useState(false)
        const [name, setName] = useState(modalData?.name ?? "");
        const [description, setDescription] = useState(modalData?.description ?? "");
        const [price, setPrice] = useState(modalData?.price ?? "");
        const [stock, setStock] = useState(modalData?.stock ?? "");
        const [releaseYear, setReleaseYear] = useState(modalData?.releaseYear ?? "");
        const [tracklist, setTracklist] = useState(modalData?.tracklist ?? [""]);
        const [published, setPublished] = useState(modalData?.published ?? false);
        const [imageUrl, setImageUrl] = useState(modalData?.imageUrl ?? null);
        const [preview, setPreview] = useState(modalData?.imageUrl ? `${process.env.REACT_APP_API_BASE_URL}/${modalData.imageUrl}` : "");

        const addTrack = () => {
            setTracklist([...tracklist, ""]);
        };

        const removeTrack = (index) => {
            setTracklist(tracklist.filter((_, i) => i !== index));
        };

        const handleChangeTrack = (index, value) => {
            const newInputs = [...tracklist];
            newInputs[index] = value;
            setTracklist(newInputs);
        };

        // API functions - patch/post/delete
        // ------------------------------------------------------------------------------
        function patchProduct(id, data) {
            setProcessed(true)
            const formData = new FormData();
            formData.append("name", data.name);
            formData.append("description", data.description);
            formData.append("price", data.price);
            formData.append("stock", data.stock);
            formData.append("category", data.category);
            formData.append("releaseYear", data.releaseYear);
            formData.append("published", data.published);
            data.tracklist.forEach(track => {
                formData.append('tracklist[]', track);
            });
            if (data.imageUrl) {
                console.log(data.imageUrl)
                formData.append("imageUrl", data.imageUrl);
            }

            const configuration = {
                method: "patch",
                url: `${process.env.REACT_APP_API_BASE_URL}/products/${id}?includeDeleted=${showDeleted}`,
                data: formData,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            axios(configuration)
                .then((result) => {
                    if (result.data.content !== undefined) {
                        setProducts(result.data.content)
                        OpsToast(result.data.message, "success")
                        handleModalsClose()
                    }
                })
                .catch((error) => {
                    opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
                });
            setProcessed(false)
        }

        function postProduct(data) {
            setProcessed(true)
            const formData = new FormData();
            formData.append("name", data.name);
            formData.append("description", data.description);
            formData.append("price", data.price);
            formData.append("stock", data.stock);
            formData.append("category", data.category);
            formData.append("releaseYear", data.releaseYear);
            formData.append("published", data.published);
            data.tracklist.forEach(track => {
                formData.append('tracklist[]', track);
            });
            if (data.imageUrl) {
                formData.append("imageUrl", data.imageUrl);
            }
            const configuration = {
                method: 'post',
                url: `${process.env.REACT_APP_API_BASE_URL}/products?includeDeleted=${showDeleted}`,
                data: formData,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }

            axios(configuration)
                .then((result) => {
                    opsToast(result?.data?.message, "success");
                    setProducts(result.data.content)
                    handleModalsClose();
                })
                .catch((error) => {
                    console.log(error)
                    opsToast(error.message, "error", "colored", true, "top-center");
                });
            setProcessed(false)
        }

        function deleteProduct(id) {
            setProcessed(true)
            const configuration = {
                method: 'delete',
                url: `${process.env.REACT_APP_API_BASE_URL}/products/${id}?includeDeleted=${showDeleted}`,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }

            axios(configuration)
                .then((result) => {
                    opsToast(result?.data?.message, "success");
                    setProducts(result.data.content)
                    handleModalsClose();
                })
                .catch((error) => {
                    console.log(error)
                    opsToast(error.message, "error", "colored", true, "top-center");
                });
            setProcessed(false)
        }

        const handleFileChange = (event) => {
            const file = event.target.files[0];
            if (file) {
                setImageUrl(file);
                setPreview(URL.createObjectURL(file));
            }
        };

        return (
            <Modal show={show} onHide={onHide} data-theme={theme} dialogClassName="custom-modal-container">
                <Modal.Header closeButton closeVariant="white"
                              className="modal-background-color">
                    <div className="fa-flex-row justify-content-between w-100 h-100">
                        <OpsText type="title" weight={700} color="primary-3" alignment="left"
                                 content={`${name}`}/>
                        {hasRoleAccess(sectionId, user.role) && modalData && <OpsBtn
                            icon={<FaTrashCan color="color-1" className="ops-icon-sm m-1"/>}
                            disabled
                            id="del-product-btn"
                            tooltipText="Zmazanie produktu nie je možné!"
                            tooltipPlacement="left"
                            variant="icon me-2"
                            padding={false}
                            action={() => {
                                const actual_article = modalData;
                                handleModalsClose()
                                opsConfirmDialog(
                                    "Vymazanie produktu",
                                    `Naozaj si prajete odstrániť produkt?`,
                                    theme,
                                    () => deleteProduct(actual_article._id),
                                    () => handleOpenModalProduct(actual_article)
                                )
                            }}
                        />}
                    </div>
                </Modal.Header>

                <Modal.Body className="modal-background-color fa-flex-col align-items-center">
                    {/*{!processed && !loadingProduct ?*/}
                    {!processed ?
                        <div className="custom-modal-content justify-content-between">
                            {/*HLAVICKA*/}
                            <div className="desktop-row-phone-col justify-content-between w-100 mb-2">
                                {modalData && <div className="fa-flex-col">
                                    <OpsText type="label" alignment="left" color="color-1"
                                             content={`Upravené: ${formatDate(modalData.updatedAt, true)}`}/>
                                    <OpsText type="label" alignment="left" color="color-1"
                                             content={`Vytvorené: ${formatDate(modalData.createdAt, true)}`}/>
                                </div>}
                                {/*DOCASNE DISABLED - iba prototyp eshopu, vsetky produkty verejne*/}
                                {/*<div className="fa-flex-col align-items-end gap-1">*/}
                                {/*    <OpsText type="label" alignment="right" color="color-1"*/}
                                {/*             content={published ? 'Zrušiť zverejnenie' : 'Zverejniť'}/>*/}
                                {/*    <OpsInput customType="switch" checked={published}*/}
                                {/*              onChange={() => setPublished(!published)}*/}
                                {/*    />*/}
                                {/*</div>*/}
                            </div>

                            {/*NAZOV A POPIS*/}
                            <div className="fa-flex-col">
                                <OpsText type="subtitle" color="primary-3 fa-w-100" weight={600}
                                         alignment="left"
                                         content="Základné informácie"/>
                                <OpsInput
                                    required
                                    id="title"
                                    label="Názov produktu"
                                    placeholder="Zadajte názov pre produkt s max. dĺžkou 60 znakov"
                                    maxLength={60}
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />

                                <OpsInput
                                    required
                                    customType="textarea"
                                    id="subtitle"
                                    label="Popis"
                                    placeholder="Zadajte popis pre produkt s odporučanou dĺžkou 200 znakov"
                                    maxLength={800}
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                />

                                <OpsInput
                                    required
                                    id="price"
                                    label="Cena (v EUR)"
                                    size="sm-2"
                                    placeholder="Cena produktu v eurách"
                                    value={price}
                                    onChange={(e) => setPrice(e.target.value)}
                                />

                                <OpsInput
                                    required
                                    id="price"
                                    label="Počet kusov"
                                    size="sm-2"
                                    placeholder="Počet kusov na sklade"
                                    value={stock}
                                    onChange={(e) => setStock(e.target.value)}
                                />

                                <OpsInput
                                    required
                                    id="releaseYear"
                                    label="Rok vydania"
                                    size="sm-2"
                                    placeholder="Rok vydania (napr. 2025)"
                                    value={releaseYear}
                                    onChange={(e) => setReleaseYear(e.target.value)}
                                />
                            </div>

                            {/* TRACKLIST */}
                            <OpsText type="subtitle" color="primary-3 fa-w-100 mt-3 mb-2" weight={600}
                                     alignment="left"
                                     content="Zoznam skladieb"/>
                            {tracklist.map((stock, index) => (
                                <div key={index} className="desktop-row-phone-col fa-w-100 gap-2 mb-2">
                                    <OpsInput
                                        required
                                        id={`price-${index}`}
                                        size="bg"
                                        placeholder="Zadajte názov skladby"
                                        value={stock}
                                        onChange={(e) => handleChangeTrack(index, e.target.value)}
                                    />
                                    <div className="fa-flex-row mb-2">
                                        <OpsBtn
                                            id="mdl-add-track"
                                            tooltipText="Pridať skladbu"
                                            icon={<FaPlus color="var(--color-p-300)"
                                                          className="ops-icon-sm m-1"/>}
                                            variant="icon mx-1"
                                            backgroundColor={`bg-g-2 border border-1`}
                                            padding={false}
                                            action={addTrack}
                                        />
                                        {index > 0 && (
                                            <OpsBtn
                                                id="mdl-delete-track"
                                                tooltipText="Odstrániť skladbu"
                                                icon={<FaTrashCan
                                                    color="var(--color-p-300)"
                                                    className="ops-icon-sm m-1"/>}
                                                variant="icon mx-1"
                                                backgroundColor={`bg-g-2 border border-1`}
                                                padding={false}
                                                action={() => removeTrack(index)}
                                            />
                                        )}
                                    </div>
                                </div>
                            ))}

                            {/*IMG URL*/}
                            <div className="fa-flex-col gap-1 my-2">
                                <OpsText type="normal" alignment="left" color="color-1"
                                         content="Fotografia produktu"/>
                                <div className="desktop-row-phone-col align-items-center gap-2">
                                    <OpsInput
                                        required
                                        id="coverImage"
                                        customType="imgUpload"
                                        componentClassName="fa-w-100"
                                        size="bg"
                                        value={preview}
                                        onChange={handleFileChange}
                                    />
                                </div>
                                {preview && (
                                    <img src={preview} className="object-fit-cover mt-2" alt=""/>
                                )}
                            </div>


                            {hasRoleAccess(sectionId, user.role) &&
                                <div className="desktop-row-phone-col gap-2 mt-5 w-100 justify-content-center">
                                    <OpsBtn
                                        text="Zahodiť"
                                        variant="secondary"
                                        size="md mt-2"
                                        action={() => handleModalsClose()}
                                    />
                                    <OpsBtn
                                        text="Uložiť"
                                        variant="primary"
                                        size="md mt-2"
                                        action={() => modalData !== null ? patchProduct(modalData?._id,
                                            {
                                                name: name,
                                                description: description,
                                                price: price,
                                                stock: stock,
                                                category: "album",
                                                imageUrl: imageUrl,
                                                releaseYear: releaseYear,
                                                tracklist: tracklist,
                                                published: published,
                                            }
                                        ) : postProduct(
                                            {
                                                name: name,
                                                description: description,
                                                price: price,
                                                stock: stock,
                                                category: "album",
                                                imageUrl: imageUrl,
                                                releaseYear: releaseYear,
                                                tracklist: tracklist,
                                                published: published,
                                            }
                                        )
                                        }
                                    />
                                </div>
                            }

                        </div>
                        :
                        <div className="custom-modal-content">
                            <LoadingSpinner/>
                        </div>
                    }
                </Modal.Body>
            </Modal>
        )
    }


    return (
        <div className="adm-section gap-3" id="admin-concerts">
            <ModalProduct show={modalProductShown} onHide={() => handleModalsClose()}/>

            <OpsText type="title mb-3 fa-w-100" weight={700} alignment="right"
                     content="PRODUKTY"/>

            {/* SPRAVA PRODUKTOV */}
            <div className="adm-container fa-flex-col">
                <div className="fa-flex-row fa-w-100 justify-content-between px-1 py-3 ">
                    <OpsText type="normal4 mt-1" weight={700} color="primary-6" alignment="left"
                             content="Správa produktov"/>
                    {/*TODO: pridavanie produktov nie je dovolene*/}
                    {/*<div className="fa-flex-row">*/}
                    {/*    /!*VYTVORIT PRODUKT<*!/*/}
                    {/*    <OpsBtn*/}
                    {/*        id="tbl-create"*/}
                    {/*        tooltipText="Pridať produkt"*/}
                    {/*        icon={<FaPlus color="var(--color-p-300)"*/}
                    {/*                      className="ops-icon-sm m-1 mx-3"/>}*/}
                    {/*        variant="icon mx-1"*/}
                    {/*        backgroundColor="bg-3 border border-1"*/}
                    {/*        padding={false}*/}
                    {/*        action={() => {*/}
                    {/*            handleOpenModalProduct()*/}
                    {/*        }}*/}
                    {/*    />*/}
                    {/*    /!*ZOBRAZIT AJ ZMAZANE*!/*/}
                    {/*    <OpsBtn*/}
                    {/*        id="tbl-filter-deleted"*/}
                    {/*        tooltipText="Zobraziť zmazané produkty"*/}
                    {/*        icon={<FiFilter color={!showDeleted ? "var(--color-p-300)" : "var(--color-1)"}*/}
                    {/*                        className="ops-icon-sm m-1"/>}*/}
                    {/*        variant="icon mx-1"*/}
                    {/*        backgroundColor={`${!showDeleted ? 'bg-3' : 'bg-primary-3'} border border-1`}*/}
                    {/*        padding={false}*/}
                    {/*        action={() => {*/}
                    {/*            setShowDeleted(!showDeleted)*/}
                    {/*            getProducts(!showDeleted)*/}
                    {/*        }}*/}
                    {/*    />*/}
                    {/*</div>*/}
                </div>
                {/*HLAVNA TABUĽKA*/}
                <OpsTable
                    id="concerts"
                    name=""
                    theme={theme}
                    classname=""
                    columns={[
                        {
                            name: "Názov",
                            selector: row => row.name,
                            sortable: true,
                            width: '45%',
                            cell: (row) => (
                                <OpsText
                                    alignment="left" nowrap textEllipsis
                                    lineThrough={row.deleted} color={row.deleted && 'color-g-2'}
                                    content={row.name}
                                />
                            )
                        },
                        {
                            name: "Cena",
                            selector: row => row.price,
                            sortable: false,
                            width: '10%',
                            center: true,
                            cell: (row) => (
                                <OpsText
                                    type="label8"
                                    alignment="left" nowrap textEllipsis
                                    lineThrough={row.deleted} color={row.deleted && 'color-g-2'}
                                    content={`${row.price} €`}
                                />
                            )
                        },
                        {
                            name: "Ks",
                            selector: row => row.stock,
                            sortable: false,
                            width: '10%',
                            center: true,
                            cell: (row) => (
                                <OpsText
                                    type="label8"
                                    alignment="left" nowrap textEllipsis
                                    lineThrough={row.deleted} color={row.deleted && 'color-g-2'}
                                    content={`${row.stock}x`}
                                />
                            )
                        },
                        {
                            name: "",
                            selector: row => row.published,
                            sortable: false,
                            width: '5%',
                            center: true,
                            cell: (row) =>
                                <OpsIconStatus
                                    status={row.published === true ? 'completed' : ''}/>
                        },
                        {
                            name: "",
                            sortable: false,
                            selector: null,
                            width: '15%',
                            cell: (row) => [
                                !row.deleted && !row.shippingSupplement && <OpsBtn
                                    key={0}
                                    icon={<BiSolidEdit className="ops-icon-sm"/>}
                                    variant="icon mx-1 ops-tbl-btn-icon"
                                    backgroundColor={row.deleted ? "bg-g-2" : "bg-primary-3"}
                                    padding={false}
                                    action={() => handleOpenModalProduct(row)}
                                />,
                                row.deleted && !row.shippingSupplement && <OpsBtn
                                    key={1}
                                    icon={<TbRestore className="ops-icon-sm"/>}
                                    variant="icon mx-1 ops-tbl-btn-icon"
                                    backgroundColor="bg-g-2"
                                    padding={false}
                                    action={() => {
                                        opsConfirmDialog(
                                            "Obnovenie produktu",
                                            `Naozaj si prajete obnoviť produkt?`,
                                            theme,
                                            () => restoreProduct(row._id),
                                            () => null
                                        )
                                    }}
                                />,
                                // TODO: /ne/zverejnovanie produktov nie je dovolene
                                // !row.deleted && !row.shippingSupplement && <OpsBtn
                                //     key={2}
                                //     icon={<BiShow className="ops-icon-sm"/>}
                                //     variant="icon mx-1 ops-tbl-btn-icon"
                                //     id="publish-product-btn"
                                //     tooltipText="Aktuálne sú všetky produkty uverejnené a nie je možné meniť ich stav"
                                //     backgroundColor={!row.published ? "bg-g-2" : "bg-primary-3"}
                                //     disabled
                                //     padding={false}
                                //     action={() => {
                                //         opsConfirmDialog(
                                //             "Zverejnenie produktu",
                                //             `Naozaj si prajete ${row.published ? 'zrušiť uverejnenie produktu' : 'uverejniť produkt'}?`,
                                //             theme,
                                //             () => patchProduct(row._id, {published: !row.published}),
                                //             () => null
                                //         )
                                //
                                //     }}
                                // />
                            ]
                        }
                    ]}
                    data={loading === false ? products : []}
                />
            </div>
        </div>
    )
}

export default AdminProducts;